import { useRef } from 'react';

export function useDerivedState(cb: (isInitialRender: boolean) => void, deps: unknown[]): void {
    const prevDepsRef = useRef<unknown[] | null>(null);
    const prevDeps = prevDepsRef.current;
    const isInitialRender = prevDeps === null;

    if (isInitialRender || !areDepsEqual(prevDeps, deps)) {
        prevDepsRef.current = deps;
        cb(isInitialRender);
    }
}

function areDepsEqual(prevDeps: unknown[], deps: unknown[]): boolean {
    return prevDeps.length === deps.length && prevDeps.every((prevDep, i) => prevDep === deps[i]);
}
